<svelte:head>
	<script defer src="/cdn-cgi/zaraz/i.js" referrerpolicy="origin"></script>
</svelte:head>
